import AudioBuild from '@app/components/audio-build';
import { NotFoundedPage } from '@app/pages';
import { useGetRecordMonitoringDataQuery } from '@app/store/api/qm-module/qm-manage/qm-manage-monitoring-tasks.api';
import React from 'react';
import { useParams } from 'react-router-dom';

const QmAppealRecord = () => {
  const { recordId, recordMonitoringFormId } = useParams();
  const { data: recordMonitoringData, isLoading: recordMonitoringLoading } =
    useGetRecordMonitoringDataQuery(
      { id: recordMonitoringFormId || '' },
      { skip: !recordMonitoringFormId },
    );

  const block = { recordMonitoringData, recordMonitoringLoading };

  if (!recordId) return <NotFoundedPage />;
  return (
    <AudioBuild
      currentTemplate={recordMonitoringData?.project.project_type || 'voice'}
      recordId={recordId}
      appeal_id={recordMonitoringData?.appellation?.appellation_id}
      appealResolveMode
      projectId={recordMonitoringData?.project.project_id}
      recordMfId={recordMonitoringFormId}
      recordMonitoring={block}
      withMetric
    />
  );
};

export default QmAppealRecord;
